import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import pdf from "../../Assets/Khushbu_Hajari_Resume.pdf";
import SocialLinks from "../SocialLinks";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";
import { FaExternalLinkAlt, FaDownload } from "react-icons/fa";

function ResumeNew() {
  return (
    <div>
      <Container fluid className="resume-section" id="resume">
        <Particle />
        <TabWindow
          activeTabId="resume"
          activeFileName="resume.pdf"
          activeIcon="📄"
          language="PDF"
          lineCount="56"
        >
          <Row className="resume-cta-row" style={{ justifyContent: "center" }}>
            <Col md={9} lg={7} className="resume-cta-col">
              <p className="terminal-cmd section-cmd">
                <span className="terminal-dollar">$</span>
                <TypeWriter text=" curl -O khushbu_resume.pdf" speed={40} />
              </p>
              <h1 className="project-heading" style={{ textAlign: "center" }}>
                <TypeWriter text="My " speed={60} cursor={false} />
                <TypeWriter text="Resume" speed={60} className="purple" tag="strong" />
              </h1>
              <p className="resume-cta-desc">
                A full overview of my experience, projects, and skills.
              </p>
              <div className="resume-cta-actions">
                <a
                  href={pdf}
                  target="_blank"
                  rel="noreferrer"
                  className="resume-cta-btn primary"
                >
                  VIEW RESUME <FaExternalLinkAlt style={{ marginLeft: "8px", fontSize: "0.85em" }} />
                </a>
                <a
                  href={pdf}
                  download="Khushbu_Hajari_Resume.pdf"
                  className="resume-cta-btn secondary"
                >
                  DOWNLOAD <FaDownload style={{ marginLeft: "8px", fontSize: "0.85em" }} />
                </a>
              </div>
            </Col>
          </Row>

          {/* Find Me On Section */}
          <SocialLinks showResume={false} />
        </TabWindow>
      </Container>
    </div>
  );
}

export default ResumeNew;
